import React from 'react';
import AdminHeader from "../components/_layout/AdminHeader";

const AdminLayout: React.FC<{ children: React.ReactNode }> = ({children}) => {
    return (
        <div className='bg-melon-light flex flex-col h-screen overflow-hidden font-medium text-melon-black font-acrom'>
            <div className='h-fit px-16 pt-4 pb-5 bg-melon-white-darker'>
                <AdminHeader/>
            </div>
            <div className='flex-1 flex px-16 mb-5 overflow-hidden'>
                {children}
            </div>
        </div>
    );
};

export default AdminLayout;